import { useContext } from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import Landing from "./Pages/landing";
import Login from "./Pages/login";
import PrivacyPolicy from "./Pages/privacyPolicy";
import DashRedirect from "./Pages/dashRedirect";
import JobBoard from "./Pages/jobBoard";
import TicketGenerator from "./Pages/ticketGenerator";
import CustomerList from "./Pages/customerList";
import CustomerProfiles from "./Pages/cutomerProfiles.js";

import AppsRedirect from "./Pages/appsRedirect";
import WikiPuzzle from "./Pages/wikiPuzzle";

import NotFound from "./Pages/notFound";

import TopNav from "./Components/TopNav";
import { UserContext } from "./Components/User";

export default function App() {
  const { isLoggedIn } = useContext(UserContext);
  return (
    <div className="App">
      <>
        <TopNav />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route
            path="/dashboard"
            element={isLoggedIn() ? <DashRedirect /> : <Navigate to="/login" />}
          >
            <Route path="job-board" element={<JobBoard />} />
            <Route path="ticket-generator" element={<TicketGenerator />} />
            <Route path="customer-list" element={<CustomerList />} />
            <Route path="customer-profiles" element={<CustomerProfiles />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/apps" element={<AppsRedirect />}>
            <Route path="wikipuzzle" element={<WikiPuzzle />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/*" element={<NotFound />} />
        </Routes>
      </>
    </div>
  );
}
